import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";
import PassResultType from "../enums/pass-result-type";

export default class PassSacked extends Fragment {
    constructor(sackedBy = [], sackedAt) {
        super();

        if (!Array.isArray(sackedBy)) {
            this.sackedBy = [sackedBy];
        } else {
            this.sackedBy = sackedBy;
        }
        this.sackedAt = sackedAt;
        this.passResultCode = PassResultType.SACKED.code;
        this.code = "SACK";

        this.requiredData = [
            {
                name: "sackedBy",
                type: FragmentDataType.Players,
                maxPlayers: 2,
                displayName: "Sack by",
                title: (team) => `Sack By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                appliesToOpponent: () => true,
                isEditable: true
            },
            {
                name: "sackedAt",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION
            }
        ];
    }

    getFieldPosition() {
        return this.sackedAt;
    }

    getPlayers() {
        return this.sackedBy;
    }

    summarize(summaryContext, stringifier) {
        const noGain = summaryContext.fieldPosition - this.sackedAt === 0;
        const gainMessage = noGain
            ? "0 yard loss"
            : stringifier.gain(
                  summaryContext,
                  summaryContext.fieldPosition,
                  this.sackedAt
              );

        const message = `sacked for ${gainMessage} to the ${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            this.sackedAt,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )} (${stringifier.firstInitial(this.sackedBy)})`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.fieldPosition = this.sackedAt;
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            sackedBy: this.sackedBy.map((p) => playerReducer(p))
        };
    }
}
